import isCompany from './isCompany'
import formatCnpj from './formatCnpj'
import formatCpf from './formatCpf'

const formatMainDocument = ({ kind, cpf, cnpj }) =>
  isCompany(kind) ? formatCnpj(cnpj) : formatCpf(cpf)

export default formatMainDocument
